<script>
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'

export default {
    name : "UserProfileForm",
    components : {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input
    },
    props : {
        userProfile : Object
    },
    data() {
        return {

        }
    },
    computed: {
        maskedPassword(){
            return "********";
        }
    },
    methods : {
        triggerClose(){
            this.$emit('close');
        },
        triggerChangePwd(){
            this.$emit('change-pass')
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">My Profile</p>
        </header>

        <section class="modal-card-body">
            <div class="columns">
                <div class="column has-text-right is-4">
                    <strong>First Name</strong>
                </div>
                <div class="column">
                    {{userProfile.firstName}}
                </div>
            </div>
            <div class="columns">
                <div class="column has-text-right is-4">
                    <strong>Last Name</strong>
                </div>
                <div class="column">
                    {{userProfile.lastName}}
                </div>
            </div>
            <div class="columns">
                <div class="column has-text-right is-4">
                    <strong>Email Address</strong>
                </div>
                <div class="column">
                    {{userProfile.email}}
                </div>
            </div>
            <div class="is-divider" data-content="Company/Agency"></div>
            <div class="columns"
                v-if="userProfile.role!='Admin' && userProfile.role!='Independent Administrator'">
                <div class="column has-text-right is-4">
                    <strong>Reporting Group</strong>
                </div>
                <div class="column">
                    <ul v-if="userProfile.reportingGroups && userProfile.reportingGroups.length > 0">
                        <li
                            v-for="(ent,entIdx) in userProfile.reportingGroups"
                            v-bind:key="entIdx">
                            <p>{{ent.reportingGroup}}</p>
                        </li>
                    </ul>
                    <div v-else>
                        No data found.
                    </div>
                </div>
            </div>
            <div class="columns"
                v-if="userProfile.role!='Admin' && userProfile.role!='Independent Administrator'">
                <div class="column has-text-right is-4">
                    <strong>Reporting Entity</strong>
                </div>
                <div class="column">
                    <ul v-if="userProfile.reportingEntities && userProfile.reportingEntities.length > 0">
                        <li
                            v-for="(ent,entIdx) in userProfile.reportingEntities"
                            v-bind:key="entIdx">
                            <p>{{ent.reportingEntity}}</p>
                        </li>
                    </ul>
                    <div v-else>
                        No data found.
                    </div>
                </div>
            </div>
            <div class="columns"
                v-if="userProfile.role!='Admin' && userProfile.role!='Independent Administrator'">
                <div class="column has-text-right is-4">
                    <strong>Reporting Unit/s</strong>
                </div>
                <div class="column">
                    <ul v-if="userProfile.reportingUnits.length > 0">
                        <li
                            v-for="unit in userProfile.reportingUnits"
                            v-bind:key="unit.repUnitId">
                            <p>{{unit.reportingUnit}}</p>
                        </li>
                    </ul>
                    <div v-else>
                        No data found.
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column has-text-right is-4">
                    <strong>Role</strong>
                </div>
                <div class="column">
                    {{userProfile.role}}
                </div>
            </div>
            <div class="is-divider" data-content="Credentials"></div>
            <div class="columns">
                <div class="column has-text-right is-4">
                    <strong>Username</strong>
                </div>
                <div class="column">
                    {{userProfile.username}}
                </div>
            </div>
            <div class="columns">
                <div class="column has-text-right is-4">
                    <strong>Password</strong>
                </div>
                <div class="column">
                    {{maskedPassword}} &nbsp; <a class="is-text" type="button" v-on:click="triggerChangePwd">Change Password</a>
                </div>
            </div>
        </section>

        <footer class="modal-card-foot has-text-left">
            <a class="button is-white"
                v-on:click="triggerClose">
                <span>Close</span>
            </a>
        </footer>
    </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserProfileForm.vue